<script>
import { mapGetters } from "vuex"
import Breadcrumbs from "@/components/layout/Breadcrumbs"
import AlarmNotificationsHeaderMenu from "@/components/alarms/notifications/AlarmNotificationsHeaderMenu.vue"

export default {
    name: "DashHeader",
    components: {
        Breadcrumbs,
        AlarmNotificationsHeaderMenu,
    },
    props: ["user"],
    data() {
        return {
            id: null,
        }
    },
    mounted() {
        this.id = this.$route.params.locationId
    },
    computed: {
        ...mapGetters("sidebar", {
            isOnMobile: "isOnMobile",
        }),
        ...mapGetters("appLayoutModule", {
            isLayoutMobile: "isMobile",
            isLayoutMobileLandscape: "isLandscapeMobile",
        }),
        title() {
            return this.$store.getters["reduxi/getPageTitle"]
        },
    },
    methods: {
        logout() {
            this.$store.dispatch("auth/logout")
            this.$router.push("/auth/login").catch(() => {})
        },
        toggleSidebar(e) {
            e.preventDefault()
            this.$store.dispatch("sidebar/toggleVisibility")
        },
    },
}
</script>

<template>
    <header class="header">
        <b-navbar toggleable="lg" type="dark" style="flex-wrap: nowrap">
            <a
                v-if="isLayoutMobile || isLayoutMobileLandscape"
                class="navbar-arrow nav-link cursor-pointer toggle-sidebar"
                @click="toggleSidebar"
            >
                <span class="icon icon-menu-bars"></span>
            </a>

            <a class="navbar-title nav-link text-primary">
                <Breadcrumbs />
            </a>

            <b-navbar-toggle target="nav-collapse" class="d-none"></b-navbar-toggle>

            <div class="ml-auto d-flex">
                <AlarmNotificationsHeaderMenu />
            </div>
        </b-navbar>
    </header>
</template>

<style>
@media (min-width: 768px) {
    .toggle-sidebar {
        display: none !important;
    }
}
</style>
